import { computed, getCurrentInstance, ref } from '@vue/composition-api'
import { FETCH_SELECTED_YEAR } from '@/modules/Invoices/_store/mutation-type'
function useSelectYear (storeKey) {
    const vm = getCurrentInstance().proxy
    const store = vm.$store

    const getYFromYM = (months) => {
        return months
            .map(month => month.substring(0, 4))
            .reduce((acc, cur, i) => {
                if (acc[acc.length - 1] !== cur) acc.push(cur)
                return acc
            }, [])
    }
    const months = computed(() => store.getters[`${storeKey ? storeKey + '/' : ''}months`])
    const yearOptions = computed(() => getYFromYM(months.value))
    const selectedYear = computed(() => store.getters[`${storeKey ? storeKey + '/' : ''}selectedYear`])
    const yearModel = ref(yearOptions.value[0] || null)

    const handleSelectYear = value => {
        if (storeKey) store.commit(`${storeKey}/${FETCH_SELECTED_YEAR}`, value)
    }

    const selectYear = value => {
        if (storeKey) store.commit(`${storeKey}/${FETCH_SELECTED_YEAR}`, value)
    }

    const setInitialYearSelect = () => {
        selectYear(yearOptions.value[0])
    }

    return {
        yearModel,
        yearOptions,
        selectedYear,
        selectYear,
        setInitialYearSelect,
        handleSelectYear,
        getYFromYM
    }
}

export default useSelectYear
